export default {
  'manualPush.pushName': 'Nombre del Mensaje',
  'manualPush.status': 'Estado',
  'manualPush.pushTime': 'Hora de Envío',
  'manualPush.createUserName': 'Operador',
  'manualPush.createTime': 'Hora de Operación',
  'manualPush.opt': 'Operación',
  'manualPush.status.standby': 'Pendiente',
  'manualPush.status.sending': 'Enviando',
  'manualPush.status.send': 'Enviado',
  'manualPush.detail': 'Detalle',
  'manualPush.add': 'Envío Manual',
  'manualPush.modalTitle.create': 'Añadir Envío Manual',
  'manualPush.selectMember': 'Seleccionar Miembro',
  'manualPush.allMembers': 'Todos los Miembros',
  'manualPush.partialMembers': 'Miembro',
  'manualPush.agent': 'Agente',
  'manualPush.memberImport': 'Importación de Documento',
  'manualPush.member': 'Miembro',
  'manualPush.sendTitle': 'Título de Envío',
  'manualPush.pushContent': 'Contenido del Envío',
  'manualPush.jumpPath': 'Ruta de Salto',
  'manualPush.siteStatus': 'Alternar Envío en Bandeja',
  'manualPush.siteStatus.open': 'Habilitado',
  'manualPush.siteStatus.close': 'Deshabilitado',
  'manualPush.pleaseSelectSiteStatus': 'Por favor seleccione alternar envío en bandeja',
  'manualPush.siteType': 'Tipo de Mensaje de Bandeja',
  'manualPush.pleaseSelectSiteType': 'Por favor seleccione tipo de mensaje de bandeja',
  'manualPush.siteType.system': 'Mensaje del Sistema',
  'manualPush.siteType.promos': 'Mensaje de Promoción',
  'manualPush.siteType.platform': 'Mensaje de Plataforma',
  'manualPush.pleaseInputPushName': 'Por favor ingrese nombre del mensaje',
  'manualPush.pleaseInputSendTitle': 'Por favor ingrese título de envío',
  'manualPush.pleaseInputPushContent': 'Por favor ingrese contenido del envío',
  'manualPush.pleaseInputMembers': 'Por favor ingrese cuentas de miembros',
  'manualPush.pleaseEnter': 'Por favor ingrese',
  'manualPush.max50Characters': 'Dentro de 50 caracteres',
  'manualPush.max500Characters': 'Dentro de 500 caracteres',
  'manualPush.enterMemberAccounts': 'Por favor ingrese cuentas de miembros, separe múltiples cuentas con comas',
  'manualPush.enterAgentAccounts': 'Por favor ingrese cuentas de agentes, separe múltiples cuentas con comas',
  'manualPush.pleaseInputAgents': 'Por favor ingrese cuentas de agentes',
  'manualPush.excelFile': 'Archivo de Excel',
  'manualPush.pleaseUploadExcelFile': 'Por favor cargue archivo de Excel',
  'manualPush.fileSizeLimit': 'El tamaño del archivo no puede exceder 10MB',
  'manualPush.clickToUpload': 'Haga clic para cargar',
  'manualPush.excelFileFormat': 'Soporta formatos .xlsx y .xls',
  'manualPush.createSuccess': 'Creado exitosamente',
  'manualPush.createFailed': 'Creación fallida',
  'manualPush.formValidationFailed': 'Validación de formulario fallida',
  'manualPush.downloadSample': 'Descargar Muestra',
  'manualPush.sampleFileDownloaded': 'Archivo de muestra descargado',
  'manualPush.uploadInstructions': 'Instrucciones de Carga',
  'manualPush.instruction1': 'La segunda columna debe contener cuentas de miembros',
  'manualPush.instruction2': 'El tamaño del archivo no puede exceder 10MB',
  'manualPush.instruction3': 'Soporta formatos .xlsx y .xls',
  'manualPush.membersList': 'Miembros de Envío',
  'manualPush.membersCount': 'miembros',
  'manualPush.reportDetail': 'Detalle de Reporte de Envío',
  'manualPush.pushStatus': 'Estado del Envío',
  'manualPush.pushStatus.success': 'Envío Exitoso',
  'manualPush.pushStatus.failed': 'Envío Fallido',
  'manualPush.pushStatus.pending': 'Envío Pendiente',
  'manualPush.failureReason': 'Razón del Fallo',
  'manualPush.date': 'Fecha',
  'manualPush.operator': 'Operador',
  'manualPush.sendUserCount': 'Cantidad de Usuarios Enviados',
  'manualPush.pushSuccessToFailed': 'Envío Exitoso/Fallido',
  'manualPush.pushOpenCount': 'Cantidad de Aperturas de Envío',
  'manualPush.siteMessageSwitch': 'Cambio de Mensaje de Bandeja',
  'manualPush.memberType': 'Tipo de Miembro',
  'manualPush.memberType.specify': 'Miembros Especificados',
  'manualPush.memberType.agent': 'Agente',
  'manualPush.memberType.import': 'Importación de Documento',
  'manualPush.memberType.all': 'Todos los Miembros',
  'manualPush.pushOpenRate': 'Tasa de Apertura de Envío',
};
